import React, { useEffect } from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  OutlinedInput,
  FormHelperText,
} from "@mui/material";
const normalizeValue = (val) => {
  if (Array.isArray(val)) return val;
  if (typeof val === "string" && val.trim() !== "") return [val]; // convert string to array
  return [];
};
const MultiSelectDropdownWidget = ({
  id,
  label,
  options,
  value = [],
  required,
  disabled,
  readonly,
  onChange,
  onBlur,
  onFocus,
  placeholder,
  rawErrors = [],
}) => {
  const { enumOptions = [], enumDisabled = [] } = options;
  const normalizedValue = normalizeValue(value);

  const handleChange = (event) => {
    const newValue = event.target.value;
    const normalized = Array.isArray(newValue)
      ? newValue
      : typeof newValue === "string" && newValue.trim() !== ""
      ? [newValue]
      : [];

    onChange(normalized);
  };

  useEffect(() => {
    if (typeof value === "string" && value.trim() !== "") {
      onChange([value]);
    }
  }, [value, onChange]);

  // Map selected values to their labels (if available)
  const renderSelectedValues = (selected) => {
    if (!Array.isArray(selected)) return "";
    const labels = selected.map(
      (val) => enumOptions.find((opt) => opt.value === val)?.label || val
    );
    return labels.join(", ");
  };

  return (
    <FormControl
      fullWidth
      error={rawErrors.length > 0}
      disabled={disabled || readonly}
    >
      <InputLabel id={`${id}-label`} required={required}>
        {label}
      </InputLabel>
      <Select
        labelId={`${id}-label`}
        id={id}
        required={required}
        multiple
        value={normalizedValue}
        onChange={handleChange}
        onBlur={onBlur && (() => onBlur(id, value))}
        onFocus={onFocus && (() => onFocus(id, value))}
        input={<OutlinedInput label={label} />}
        renderValue={renderSelectedValues}
      >
        {enumOptions.map((option) => (
          <MenuItem
            key={option.value}
            value={option.value}
            disabled={enumDisabled.includes(option.value)}
          >
            <Checkbox checked={normalizedValue.includes(option.value)} />
            <ListItemText primary={option.label} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default MultiSelectDropdownWidget;
